import { gql } from '@apollo/client';

export default gql`
  query spaces($page: Int) {
    spaces(page: $page) {
      spacesTotalPages
      spacesTotal
      perPage
      hasNextPage
      currentPage
      spaces {
        id
        name
      }
    }
  }
`;
